<template>
    <div class="w-full">
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Input Number:
        </div>
        <div class="flex flex-col gap-3">
            <RedesignInputNumber
                v-model="numberInput"
                placeholder="0"
            />
            <RedesignInputNumber
                placeholder="00"
                disabled
            />
            <div class="py-2">
                val: {{ numberInput }}
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Base Input:
        </div>
        <div>
            <RedesignBaseInput
                v-model="baseInput"
                clearable
                class="mb-3"
            />
            <RedesignBaseInput
                :value="'disabled'"
                clearable
                disabled
            />
            <div class="py-2">
                Val: {{ baseInput }}
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Base Textarea:
        </div>
        <div>
            <RedesignBaseInput
                v-model="baseTextInput"
                type="textarea"
            />
            <div class="py-2">
                Val: {{ baseTextInput }}
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Base Form:
        </div>
        <div>
            <RedesignBaseForm
                ref="formRef"
                :model="formModel"
                class="example-form"
            >
                <redesign-form-item
                    :rules="rules.name"
                    label="Name Label"
                    icon="Pencil"
                    prop="name"
                >
                    <RedesignBaseInput
                        v-model="formModel.name"
                    />
                </redesign-form-item>
                <redesign-form-item
                    :rules="rules.age"
                    label="Age Label"
                    prop="age"
                >
                    <RedesignInputNumber
                        v-model="formModel.age"
                    />
                </redesign-form-item>
            </RedesignBaseForm>
            <div class="py-3">
                <RedesignBaseButton
                    label="Save"
                    @click="onFormValidate"
                />
            </div>
            <div class="text-primary-600 font-medium text-main-lg mb-2">
                Base Checkboxes:
            </div>
            <div>
                <RedesignCheckbox
                    v-model="baseCheckbox"
                >
                    Base Checkbox
                </RedesignCheckbox>
                <RedesignCheckbox
                    :value="true"
                    disabled
                >
                    Disabled Checkbox
                </RedesignCheckbox>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Bordered checkboxes:
            </div>
            <div>
                <RedesignCheckbox
                    v-model="baseCheckbox"
                    border
                >
                    Base Checkbox
                </RedesignCheckbox>
                <RedesignCheckbox
                    :value="true"
                    border
                    disabled
                >
                    Disabled Checkbox
                </RedesignCheckbox>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Group checkboxes:
            </div>
            <div>
                <RedesignCheckbox
                    v-model="checkAll"
                    :indeterminate="isIndeterminate"
                    @change="handleCheckAllChange"
                >
                    Check All
                </RedesignCheckbox>
                <RedesignCheckboxGroup
                    v-model="checkedGroup"
                    @change="handleChangeGroup"
                >
                    <RedesignCheckbox
                        v-for="item in checkboxes"
                        :key="item"
                        :label="item"
                    >
                        {{ item }}
                    </RedesignCheckbox>
                </RedesignCheckboxGroup>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Buttons checkboxes:
            </div>
            <div>
                <RedesignCheckboxGroup
                    v-model="checkedGroup1"
                >
                    <RedesignCheckboxButton
                        v-for="item in checkboxes"
                        :key="item"
                        :label="item"
                    >
                        {{ item }}
                    </RedesignCheckboxButton>
                </RedesignCheckboxGroup>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Base Radio:
            </div>
            <div class="flex flex-col gap-4">
                <div class="flex items-center gap-4">
                    <RedesignRadio
                        v-model="radioSimple"
                        label="Option 1"
                        :data-value="1"
                    />
                    <RedesignRadio
                        v-model="radioSimple"
                        label="Option 2"
                        :data-value="2"
                    />
                </div>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Base Bordered Radio:
            </div>
            <div class="flex flex-col gap-4">
                <div class="flex items-center gap-4">
                    <RedesignRadioGroup
                        v-model="radioBorder"
                        class="!flex items-center"
                    >
                        <RedesignRadio
                            label="Option 1"
                            :data-value="1"
                            border
                        />
                        <RedesignRadio
                            label="Option 2"
                            :data-value="2"
                            border
                        />
                    </RedesignRadioGroup>
                </div>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Button Style Radio:
            </div>
            <div class="flex flex-col">
                <div class="flex items-center">
                    <RedesignRadioGroup v-model="radioBtn">
                        <RedesignRadioButton label="New York" />
                        <RedesignRadioButton label="Washington" />
                        <RedesignRadioButton
                            label="Los Angeles"
                            disabled
                        />
                        <RedesignRadioButton label="Chicago" />
                    </RedesignRadioGroup>
                </div>
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Base Switcher:
            </div>
            <div class="flex flex-col gap-4">
                <RedesignSwitch
                    v-model="baseSwitch"
                />
                <RedesignSwitch
                    v-model="baseSwitch"
                    disabled
                />
                <RedesignSwitch
                    v-model="baseSwitch1"
                    active-text="Active Label"
                    inactive-text="Inactive Label"
                />
                <RedesignSwitch
                    v-model="baseSwitch2"
                    active-color="#22c55e"
                    inactive-color="var(--destructive-actions)"
                    active-text="Active Label"
                    inactive-text="Inactive Label"
                />
            </div>
            <div class="font-medium text-primary-600 text-main-lg my-2">
                Base Select:
            </div>
            <div>
                <RedesignBaseSelect
                    v-model="selectValue"
                    :data="selectData"
                    :config="{
                        labelKey: 'label',
                        valueKey: 'value'
                    }"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import RedesignBaseInput from '@/components/RedesignBaseComponents/Inputs/RedesignBaseInput.vue'
import RedesignBaseForm from '@/components/RedesignBaseComponents/Form/RedesignBaseForm.vue'
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import RedesignCheckbox from '@/components/RedesignBaseComponents/Inputs/RedesignCheckbox.vue'
import RedesignCheckboxGroup from '@/components/RedesignBaseComponents/Inputs/RedesignCheckboxGroup.vue'
import RedesignCheckboxButton from '@/components/RedesignBaseComponents/Inputs/RedesignCheckboxButton.vue'
import RedesignSwitch from '@/components/RedesignBaseComponents/Inputs/RedesignSwitch.vue'
import RedesignBaseSelect from '@/components/RedesignBaseComponents/Inputs/RedesignBaseSelect.vue'
import RedesignRadio from '@/components/RedesignBaseComponents/Inputs/RedesignRadio.vue'
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import RedesignRadioButton from '@/components/RedesignBaseComponents/Inputs/RedesignRadioButton.vue'

const numberInput = ref()
const baseInput = ref('')
const baseTextInput = ref('')
const baseCheckbox = ref<boolean>(false)
const checkAll = ref<boolean>(false)
const checkedGroup = ref<Array<string>>([])
const checkedGroup1 = ref<Array<string>>([])
const baseSwitch = ref<boolean>(false)
const baseSwitch1 = ref<boolean>(false)
const baseSwitch2 = ref<boolean>(false)
const selectValue = ref([])

const radioSimple = ref(undefined)
const radioBorder = ref(undefined)
const radioBtn = ref(undefined)

const formRef = ref()
const formModel = ref({
    name: '',
    age: 20
})

const isIndeterminate = computed(() => {
    return !!(checkedGroup.value?.length && checkedGroup.value?.length < checkboxes.length)
})

const rules = {
    name: [
        {
            required: true,
            message: 'Please input Activity name'
        },
        {
            min: 3,
            max: 5,
            message: 'Length should be 3 to 5'
        }
    ],
    age: [
        {
            required: true,
            message: 'age is required'
        }
    ]
}
const checkboxes = [
    'Checkbox 1',
    'Checkbox 2',
    'Checkbox 3',
    'Checkbox 4',
    'Checkbox 5'
]

const selectData = [ {
    value: 'Option1',
    label: 'Option1'
}, {
    value: 'Option2',
    label: 'Option2'
}, {
    value: 'Option3',
    label: 'Option3'
}, {
    value: 'Option4',
    label: 'Option4'
}, {
    value: 'Option5',
    label: 'Option5'
} ]

function onFormValidate () {
    formRef.value?.validate()
        .then((res: { isValid: boolean }) => {
            console.log({ res })
        })
}
function handleCheckAllChange (val: boolean | string | number) {
    if (val) {
        checkedGroup.value = [ ...checkboxes ]
    } else {
        checkedGroup.value = [ ]
    }
}
function handleChangeGroup (val: Array<string>) {
    checkAll.value = val.length === checkboxes.length
}
</script>

<style lang="scss">

</style>
